import React, { useState, useEffect } from "react";
import SaveChangesButton from "./SaveChangesButton";

const SMSSetting = ({ helpData, setHelpData, originalHelpData, handleHelpSubmit }) => {
    const [hasChanges, setHasChanges] = useState(false);



    const safeHelpData = {
        account_sid: helpData?.account_sid || "",
        auth_token: helpData?.auth_token || "",
        phone_number: helpData?.phone_number || "",

    };








    useEffect(() => {
        if (!originalHelpData) {
            setHasChanges(true); // Always show save on first render when there's no existing meta
            return;
        }
        const baseData = { ...safeHelpData};
        const original = { ...originalHelpData};
        const changed =
            JSON.stringify(baseData) !== JSON.stringify(original) ;
        setHasChanges(changed);
    }, [safeHelpData, originalHelpData]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setHelpData((prev) => ({ ...prev, [name]: value }));
    };

   




    // const onSubmit = () => {
    //   handleHelpSubmit({ ...safeHelpData }, iconFile); 
    //     setIconFile(null);
    // };

    const onSubmit = async () => {
        const finalData = {
            ...safeHelpData,
        };

        await handleHelpSubmit(finalData);
    };

    return (
        <div className="profile-form-container">
            <div className="profile-form-group">
                <label className="profile-form-label">TWILIO ACCOUNT SID</label>
                <input
                    type="text"
                    name="account_sid"
                    value={safeHelpData.account_sid}
                    onChange={handleChange}
                    className="profile-form-input"
                    placeholder="Enter twilio account sid"
                />
            </div>
            <div className="profile-form-group">
                <label className="profile-form-label">TWILIO AUTH TOKEN</label>
                <input
                    type="text"
                    name="auth_token"
                    value={safeHelpData.auth_token}
                    onChange={handleChange}
                    className="profile-form-input"
                    placeholder="Enter twilio auth token"
                />
            </div>
            <div className="profile-form-group">
                <label className="profile-form-label">TWILIO PHONE NUMBER</label>
                <input
                    type="text"
                    name="phone_number"
                    value={safeHelpData.phone_number}
                    onChange={handleChange}
                    className="profile-form-input"
                    placeholder="Enter twilio phone number"
                />
            </div>


          
                <div className="profile-form-group full-span">
                    <SaveChangesButton onClick={onSubmit} />
                </div>
        


        </div>
    );
};

export default SMSSetting;
